import { Modal } from "ant-design-vue";
import { reactive, ref } from 'vue';
import { apiRoutes } from '../infraestructure/apiRoutes';
import { buildQueryParameters, get, post } from '../infraestructure/repository/generic.repository';

const useBusinessUnit = () => {

  // ****************************************************************
  // ****************************************************************
  // VARIABLES INITIALIZATION

  // Paginator constants
  let paginatorTotalItems = ref(0)
  let paginatorTotalPages = ref(0)
  let paginatorCurrentPage = ref(0)

  const searchText = ref('')
  const formId = ref('')

  // ERROR VARIABLES
  const consignmentNotes = ref([])
  const tableLoading = ref(false)
  // VARIABLES INITIALIZATION
  // ****************************************************************
  // ****************************************************************

  const formLoad = ref(false)
  const visible = ref(false)
  const updateType = ref('')
  const processOptions = [
    { key: 'consignmentSetting', value: 'Leyendas Carta Porte' },
    { key: 'businessSetting', value: 'Razón Social Holcim' },
  ]

  let errorHandler = reactive({
    errorDescription: {
      errors: [],
    },
    errorNumber: 0,
  })
  const consignmentNoteId = ref('')
  let formProcess = reactive({
    process: '',
  })
  const rules = {
    process: [{ required: true, message: 'El tipo de información a actualizar es obligatorio' }],
  }

  const openModal = (data = null) => {
    visible.value = true
    consignmentNoteId.value = data.id
  }
  const closeModal = () => {
    visible.value = false
    consignmentNoteId.value = ''
    formProcess.process = ''
  }

  const businessSettingType = 'businessSetting'
  const submit = async () => {
    formLoad.value = true

    const path = formProcess.process === businessSettingType ? apiRoutes.resourcebusinessSetting : apiRoutes.resourceConsignmentSetting
    await post(path, { consignmentNoteId: consignmentNoteId.value }).then(() => {

      Modal.success({
        title: `¡El registro se ha actualizado exitosamente!`,
      })
      closeModal()
      formLoad.value = false

    }).catch(error => {

      const { errorDescription, errorNumber } = error.response.data
      errorHandler.errorDescription = errorDescription
      errorHandler.errorNumber = errorNumber

      formLoad.value = false

    })

    formLoad.value = false
  }

  const onChangePaginator = async (current) => {
    await getConsignmentNotes(10, (current - 1))
  }

  const getConsignmentNotes = async (limit = 10, page = 0) => {
    tableLoading.value = true

    const path = `${apiRoutes.consignmentNote}${buildQueryParameters(searchText, limit, page)}`
    const response = await get(path)
    const { items, total, totalPages, currentPage } = response.data

    consignmentNotes.value = items
    paginatorTotalItems.value = total
    paginatorTotalPages.value = totalPages
    paginatorCurrentPage.value = currentPage

    tableLoading.value = false
  }
  getConsignmentNotes(10, 0)

  const handleChange = (selectedItem) => {
    formProcess.process = selectedItem
  }

  return {
    searchText,
    formId,
    consignmentNotes,
    tableLoading,

    paginatorTotalItems,
    paginatorTotalPages,
    paginatorCurrentPage,
    onChangePaginator,

    getConsignmentNotes,

    formLoad,
    visible,
    updateType,
    processOptions,
    errorHandler,
    consignmentNoteId,
    formProcess,
    rules,
    openModal,
    closeModal,
    businessSettingType,
    submit,

    handleChange,
  }
}

export default useBusinessUnit

